export const MEAL_TYPES = ['Breakfast', 'Lunch', 'Dinner'];

const parseCalories = (value) => {
	if (typeof value === 'number' && Number.isFinite(value)) {
		return Math.round(value);
	}

	if (typeof value === 'string') {
		const match = value.match(/\d+/);
		if (match) {
			return Number(match[0]);
		}
	}

	return null;
};

export const normalizeMealEntry = (mealEntry) => {
	if (typeof mealEntry === 'string') {
		return {
			name: mealEntry,
			calories: null,
		};
	}

	if (mealEntry && typeof mealEntry === 'object') {
		const possibleNames = [mealEntry.name, mealEntry.meal, mealEntry.dish, mealEntry.title];
		const name = possibleNames.find((value) => typeof value === 'string' && value.trim()) || '';
		return {
			name,
			calories: parseCalories(mealEntry.calories),
		};
	}

	return {
		name: '',
		calories: null,
	};
};

export const getMealEntriesForDay = (day) => (
	MEAL_TYPES
		.filter((mealType) => day && day[mealType] !== undefined && day[mealType] !== null)
		.map((mealType) => ({
			mealType,
			...normalizeMealEntry(day[mealType]),
		}))
);

export const normalizeMealPlan = (plan) => {
	if (!plan || typeof plan !== 'object') return plan;

	const normalizedDays = Array.isArray(plan.days)
		? plan.days.map((day) => {
			const normalizedDay = {};
			MEAL_TYPES.forEach((mealType) => {
				normalizedDay[mealType] = normalizeMealEntry(day?.[mealType]);
			});
			return normalizedDay;
		})
		: [];

	return {
		...plan,
		days: normalizedDays,
	};
};
